import { useEffect, useState } from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import RequestForm from "./RequestForm";
import { Roles } from "../../utils/constants";
import { getRequests } from "../../services/AvailabilityService";
import Table from "../../components/Table";
import { getCurrentUser, getFullName } from "../../utils/utils";
import { ReactComponent as SuccessIcon } from "../../static/icons/success.svg";
import { ReactComponent as ExpandIcon } from "../../static/icons/expand.svg";
import PrimaryButton from "../../components/PrimaryButton";
import SecondaryButton from "../../components/SecondaryButton";
import useWindowDimensions from "../../utils/hooks/getWindowDimensions";
import AvailabilityModal from "./AvailabilityModal";

const RequestList = () => {
  const [requests, setRequests] = useState([]);
  const [availabilitiesModal, setAvailabilitiesModal] = useState({
    open: false,
    id: null,
  });
  const [requestFormModal, setRequestFormModal] = useState({
    open: false,
    id: null,
  });
  const user = getCurrentUser();
  const { width } = useWindowDimensions();

  useEffect(() => {
    getRequests().then((data) => setRequests(data));
  }, []);

  const columns = [
    {
      label: "Employer",
      name: "user",
      convert: (value) => getFullName(value),
    },
    {
      label: "Request Date",
      name: "created_at",
      convert: (value) =>
        new Date(value).toLocaleDateString("en-US", {
          day: "numeric",
          year: "numeric",
          month: "short",
        }),
    },
    ...(width > 600
      ? [
          {
            label: "Start Date",
            name: "from_date",
            convert: (value) =>
              new Date(value).toLocaleDateString("en-US", {
                day: "numeric",
                year: "numeric",
                month: "short",
              }),
          },
          {
            label: "End Date",
            name: "to_date",
            convert: (value) =>
              new Date(value).toLocaleDateString("en-US", {
                day: "numeric",
                year: "numeric",
                month: "short",
              }),
          },
        ]
      : []),
    {
      label: "Status",
      name: "status",
      component: (item) => {
        const date = new Date();
        date.setDate(date.getDate() - 7);
        const isIgnored = new Date(item.created_at) < date;
        let isCompleted = true;
        item.availabilities.forEach((i) => {
          if (i.hours === null) {
            isCompleted = false;
          }
        });

        return isCompleted ? (
          <SuccessIcon />
        ) : isIgnored && user.role === Roles.EMPLOYER.value ? (
          "Ignored"
        ) : (
          "Pending"
        );
      },
    },
    ...(width > 600
      ? [
          {
            hidden: true,
            type: "button",
            name: "avail-btn",
            component: (item) => (
              <SecondaryButton
                size="sm"
                onClick={() =>
                  setAvailabilitiesModal({ open: true, id: item.id })
                }
              >
                Availability
              </SecondaryButton>
            ),
          },
        ]
      : []),
    {
      hidden: true,
      type: "button",
      name: "expand-btn",
      component: (item) => (
        <a onClick={() => setRequestFormModal({ open: true, id: item.id })}>
          <ExpandIcon />
        </a>
      ),
    },
  ];

  return (
    <Container>
      <Row>
        <Table
          columns={columns}
          data={requests}
          header={
            <Container style={{ margin: "13px 13px 25px" }}>
              <Row>
                <Col>
                  <h5 className="vertical-align-text table-title">
                    {user.role === Roles.EMPLOYEE.value
                      ? "Commitments"
                      : "Requests"}
                  </h5>
                </Col>
                <Col>
                  <PrimaryButton
                    onClick={() =>
                      setRequestFormModal({
                        id: null,
                        open: true,
                      })
                    }
                    style={{ float: "right" }}
                  >
                    Create Work Request +
                  </PrimaryButton>
                </Col>
              </Row>
            </Container>
          }
        />
      </Row>
      {availabilitiesModal.id && (
        <AvailabilityModal
          open={availabilitiesModal.open}
          onClose={() =>
            setAvailabilitiesModal((oldVal) => ({ ...oldVal, open: false }))
          }
          request={requests.find((i) => i.id === availabilitiesModal.id)}
          setRequests={setRequests}
        />
      )}
      <RequestForm
        open={requestFormModal.open}
        onClose={() =>
          setRequestFormModal((oldVal) => ({ ...oldVal, open: false }))
        }
        setRequests={setRequests}
        request={requests.find((i) => i.id === requestFormModal.id)}
        setAvailabilitiesModal={setAvailabilitiesModal}
      />
    </Container>
  );
};

export default RequestList;
